module.exports = __FOREMAN_VENDOR__REACT_ELLIPSIS_WITH_TOOLTIP__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__REACT_ELLIPSIS_WITH_TOOLTIP__"
// module id = react-ellipsis-with-tooltip
// module chunks = 32